import { render, staticRenderFns } from "./ItemPartido.vue?vue&type=template&id=5e71d37c&scoped=true&"
import script from "./ItemPartido.vue?vue&type=script&lang=js&"
export * from "./ItemPartido.vue?vue&type=script&lang=js&"
import style0 from "./ItemPartido.vue?vue&type=style&index=0&id=5e71d37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71d37c",
  null
  
)

export default component.exports